/* nh2 contact page (2026). Topic preselect and focus after submit.
   Everything works without JavaScript; this only saves a click. */
(function () {
  'use strict';

  if (window.__nh2Contact) return;
  window.__nh2Contact = true;

  function selectTopic(key) {
    if (!key) return;
    var input = document.querySelector('[data-nhc-topic-value="' + key + '"]');
    if (input) input.checked = true;
  }

  function init() {
    var params = new URLSearchParams(window.location.search);
    selectTopic(params.get('topic'));

    // Links that jump to the form on this page carry the topic they are about.
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-nhc-topic]') : null;
      if (link) selectTopic(link.getAttribute('data-nhc-topic'));
    });

    // After a post, move focus to the confirmation or the error message.
    var notice = document.querySelector('[data-nhc-focus]');
    if (notice) notice.focus({ preventScroll: false });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
